
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { addUpSystemUpgrade } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiAddSystemNotice extends Vue {
  private formInline: objAny = {
    upgradeContent: "",
    upgradeTime: "",
    version: "",
    pkId: ""
  };
  private upgradeTime = "";
  private loading = false;
  private modalShow = false;
  private modalTitle = i18n.t("systemNotice.upgradeTime");

  private formObj: objAny = {};
  private ruleInline: objAny = {
    version: [
      {
        required: true,
        message: i18n.t("systemNotice.versionPl"),
        trigger: "blur"
      }
    ],
    upgradeContent: [
      {
        required: true,
        message: i18n.t("systemNotice.upgradeContentPl"),
        trigger: "blur"
      }
    ],
    upgradeTime: [
      {
        required: true,
        message: i18n.t("systemNotice.upgradeTimePl"),
        // type: "date",
        trigger: "change"
      }
    ]
  };

  public open(item?: objAny) {
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
      this.handleReset();
      if (!item) {
        this.formInline.version = "";
        this.formInline.upgradeContent = "";
        this.formInline.upgradeTime = "";
        this.formInline.pkId = null;
        this.modalTitle = i18n.t("systemNotice.add");
      } else {
        this.formInline.version = item.version;
        this.formInline.upgradeContent = item.upgradeContent;
        this.formInline.upgradeTime = item.upgradeTime;
        this.formInline.pkId = item.pkId;
        this.modalTitle = i18n.t("systemNotice.updata");
      }
    });

    this.modalShow = true;
  }

  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }

  public handleReset() {
    this.formObj.resetFields();
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const json: objAny = JSON.parse(JSON.stringify(this.formInline));
    const ret = await addUpSystemUpgrade(json);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("systemNotice.saveSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
}
